import { Component, Input } from '@angular/core';
import { QuoteHistoryDialogComponent } from '../quote-history-dialog/quote-history-dialog/quote-history-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Quote } from '@quoting/models/quote';
import { QuoteRequestService } from '@app/shared/services/quote-request.service';
import { UtilityHubIdentity } from '@auth/models/utility-hub-identity';

@Component({
  selector: 'app-quote-history-button',
  templateUrl: './quote-history-button.component.html',
  styleUrls: ['./quote-history-button.component.scss']
})
export class QuoteHistoryButtonComponent {
  
  @Input() quote: Quote;
  @Input() user: UtilityHubIdentity;

  constructor(
    private dialog: MatDialog,
    public quoteRequestService: QuoteRequestService,
  ) { }

  public getQuoteHistoryDialog(): void {
    this.dialog.open(QuoteHistoryDialogComponent, {
      width: '80%',
      height: '65%',
      data: {
        quotePriceHistory: this.quoteRequestService.getQuotePriceHistory(this.quote?.quoteRequestState?.quoteRequestId),
        title: `Quote History`,
        quote: this.quote,
        quoteRequestId: this.quote?.quoteRequestState?.quoteRequestId,
        user: this.user,
      },
    });    
  }


}
